import { Divider, MenuItem, Select } from '@mui/material';
import { useState } from 'react';
import { useLeadsStore } from 'store/leadsStore';
import { classNames } from 'util/Funcs';

interface Props {
    tabs: { name: string; component: React.ReactNode; key?: string }[];
}

const VerticalTabs: React.FC<Props> = ({ tabs }) => {
    const [currentTab, setCurrentTab] = useState(tabs[0]?.name || '');
    const { setStatus } = useLeadsStore();

    const renderContent = () => {
        const currentTabObject = tabs.find((tab) => tab.name === currentTab);
        return currentTabObject ? currentTabObject.component : null;
    };

    const handleClick = (tabName: string, key: string) => {
        setCurrentTab(tabName);
        setStatus(key);
    };

    return (
        <div className="flex w-full flex-col lg:flex-row">
            <div className="mb-4 p-4 lg:hidden">
                <Select
                    value={currentTab}
                    onChange={(e) => {
                        const tab = tabs.find((t) => t.name === e.target.value);
                        if (tab) handleClick(tab.name, tab.key!);
                    }}
                    className="min-w-[12rem] w-full"
                >
                    {tabs.map((tab) => (
                        <MenuItem key={tab.name} value={tab.name}>
                            {tab.name}
                        </MenuItem>
                    ))}
                </Select>
            </div>

            <nav aria-label="Tabs" className="hidden lg:flex flex-col gap-y-5">
                {tabs.map((tab) => (
                    <div key={tab.name} className="relative w-48 flex items-center">
                        <button
                            onClick={() => handleClick(tab.name, tab.key!)}
                            aria-current={currentTab === tab.name ? 'page' : undefined}
                            className={classNames(
                                currentTab === tab.name ? 'bg-[#3176BC]/5 text-[#3176BC]' : '',
                                'whitespace-nowrap px-1 py-4 text-sm font-medium flex-1',
                            )}
                        >
                            {tab.name}
                        </button>
                        {currentTab === tab.name && <div className="absolute right-0 top-0 h-full w-1 bg-[#3176BC]" />}
                    </div>
                ))}
            </nav>

            <Divider orientation="vertical" className="hidden lg:block" flexItem />
            {renderContent()}
        </div>
    );
};

export default VerticalTabs;
